<template>
  <div class="login">
 <Title titleName='特约供应商说明' iconLeft="back"/>


	<div class="order">

特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明特约供应商说明

	</div>



	
	
  </div>
</template>
<script>
import Title from "@/common/title";
export default {
  components: {
    Title
  },
  data() {
    return {
		baoyou:''
    
    };
  }
};
</script>
<style lang="scss" scoped>
.order{
	font-size: 28px;
	padding-bottom: 200px;
	padding: 30px;
	line-height: 50px;
}
.pro-l2{
	
	
	.can{
		
		border-bottom: 1px solid #DDDDDD;
		display: flex;
		justify-content: space-between;
		height: 100px;
		align-items: center;
		.pl{
			display: flex;
			align-items: center;
			img{
				width: 30px;
				height: 30px;
			}
			
		}
	}
	.can1{
		height: 100px;
		line-height: 100px;
		border-bottom: 1px solid #DDDDDD;
	}
	.can2{
		background: #FFFFFF;
		display: flex;
		align-items: center;
		margin-top: 20px;
		padding: 20px;
		img{
			width: 100%;
		}
		p{
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom:15px;
		}
	}
	.coupon{
		li{
			padding: 20px;
			border-bottom: 1px solid #DDDDDD;
			display: flex;
			justify-content: space-between;
		}
	}

}
	.can4{
		margin-top: 20px;
		padding: 0 20px;
		background: #FFFFFF;
		border-bottom: 1px solid #DDDDDD;
		display: flex;
		justify-content: space-between;
		height: 100px;
		align-items: center;
		.pl{
			display: flex;
			align-items: center;
			img{
				width: 30px;
				height: 30px;
			}
			input{
				border: none;
				text-align: right;
				width: 600px;
			}
		}
	}
 .pro-tit{
	 background: #FFFFFF;
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }
 .adr{
 	display: flex;
 	align-items: center;
	justify-content: space-between;
 	position: fixed;
 	bottom: 0;
 	width: 680px;
 	height: 68px;
 	background: #FFFFFF;
 	font-size: 28px;
 	box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.06);
	padding: 20px;
	.ad1{
		display: flex;
		align-items: center;
		img{
			width:40px;
			margin-right: 20px;
		}
	}
	b{
		font-size: 36px;
		color: #E42626;
	}
 }
</style>